import { put, take, race, all } from 'redux-saga/effects';
import { showAlert } from '../actions/globalActions';
import { GET_METRICS_REQUEST } from '../actions/metricsActions';
import { spinnerDecrement } from '../actions/spinnerActions';
import { buildErrorMessage } from '../utils/apiCaller';
import { GET_METRICS_SUCCESS, GET_METRICS_FAILURE, getMetricsApi } from '../apiActions/metricsApiActions';

export default function* metricsSagas() {
  yield all([getMetricsSaga()]);
}

function* getMetricsSaga() {
  while (true) {
    yield take(GET_METRICS_REQUEST);
    yield put(getMetricsApi());
    const { failure } = yield race({
      success: take(GET_METRICS_SUCCESS),
      failure: take(GET_METRICS_FAILURE),
    });
    if (failure) {
      yield put(spinnerDecrement());
      yield put(showAlert('Oops!', buildErrorMessage(failure), 'error'));
    }
  }
}
